// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"9797f319","698":"aa4c5347","751":"d37f8c9c"}[chunkId] + ".chunk.css";
};